import { Injectable } from '@angular/core';
import { de } from 'date-fns/locale';

@Injectable({
  providedIn: 'root'
})
export class CalendarUtilityService {
  millisecondPerDay = 24 * 60 * 60 * 1000;
  constructor() { }

  verifyDateFormat(date: string) {
    try {
      var dateArr = date.split('/');
      if (dateArr.length == 3)
      return dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0];
        //return dateArr[1] + '/' + dateArr[0] + '/' + dateArr[2];
      else
        return "";
    }
    catch (e) {
      console.error(e);
      return "";
    }

  }

  dateFormatForApi(date: Date, formatId: number): string {
    try {
      if (date) {
        let isvalid = !isNaN(date.getTime());
        if (isvalid) {
          let dateStr = date.getDate().toString().length > 1 ? date.getDate().toString() : "0" + date.getDate().toString();
          let monthStr = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : "0" + (date.getMonth() + 1).toString();
          let yearStr = date.getFullYear().toString();
          if (formatId == 1) {
            return `${dateStr}/${monthStr}/${yearStr}`;
          }
          else if (formatId == 2) {
            return `${dateStr}-${monthStr}-${yearStr}`;
          }
          else if (formatId == 3) {
            return `${dateStr}/${monthStr}/${yearStr}`;
          }
          else if (formatId == 4) {
            return `${monthStr}/${dateStr}/${yearStr}`;
          }
          else {
            return ""
          }
        }
        else
          return "";
      }
      return ""

    }
    catch (e) {
      return ";"
    }

  }

  dateFormatForClient(date: string, formatId: number): Date {
    try {
      if (formatId == 1) {
        var dateArr = date.split('/');
        if (dateArr.length == 3) {
          let dateObj = new Date(`${dateArr[2]}-${parseInt(dateArr[1])}-${dateArr[0]}`);
          let isvalid = !isNaN(dateObj.getTime());
          if (isvalid) {
            return dateObj
          }
          else {
            return null;
          }
        }
        else {
          return null;
        }
      }
      else if (formatId == 2) {
        var dateArr = date.split('-');
        if (dateArr.length == 3) {
          let dateObj = new Date(`${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`);
          let isvalid = !isNaN(dateObj.getTime());
          if (isvalid) {
            return dateObj
          }
          else {
            return null;
          }
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    }
    catch (e) {
      console.error(e);
      return null;
    }
  }


  getDisabledDates(dates: Date[]) {
    let disabledDates = [];
    try {
      if (dates && dates.length > 0) {

        let found = false;
        let startDate = dates[0];
        let endDate = dates[dates.length - 1];
        do {
          for (let i = 0; i < dates.length; i++) {
            var excludeDate: Date = dates[i];
            if (this.IsSameDay(excludeDate, startDate)) {
              found = true;
            }
          }
          if (!found) {
            disabledDates.push(startDate);
          }
          startDate = new Date((startDate.getTime() + this.millisecondPerDay));
          found = false;
        } while (startDate <= endDate)

      }
      return disabledDates;
    }
    catch (e) {
      console.error(e);
      return disabledDates
    }

  }


  IsSameDay(date1: Date, date2: Date) {
    try {
      if (date1.getFullYear() == date2.getFullYear() && date1.getMonth() == date2.getMonth() && date1.getDate() == date2.getDate()) {
        return true;
      }
      else {
        return false;
      }
    }
    catch (e) {
      return false;
    }

  }

  addDate(date: Date, noOfDays: number): Date {
    //var dateFormatTotime = new Date(dateInput);
    var increasedDate = new Date(date.getTime() + (noOfDays * 86400000));
    return increasedDate;
  }
  subDate(date: Date, noOfDays: number): Date {
    var decreasedDate = new Date(date.getTime() - (noOfDays * 86400000));
    return decreasedDate;
  }

  isValidDate(date: Date): boolean{
    try{
      if(!isNaN(date.getTime())){
        return true;
      }
      return false;
    }
    catch(e){
      return false;
    }
  }
}
